/**
 * iOS/iPadOS in a Safari tab: saving for offline is hidden (the copies would be invisible to the
 * installed Home-Screen app and evicted after 7 days). This banner points to the install guide.
 */
import { ChevronRight, Smartphone } from 'lucide-react';
import { Link } from 'react-router';
import { cx } from '../components/ui';
import { useT } from '../i18n';
import { needsInstallForOffline } from './hooks';

export function InstallForOfflineBanner({ className }: { className?: string }) {
  const t = useT();
  if (!needsInstallForOffline()) return null;
  return (
    <Link
      to="/install"
      className={cx(
        'flex min-h-16 items-center gap-4 rounded-2xl border border-[var(--line)] bg-[var(--accent-soft)] px-4 py-3 text-[var(--ink)] transition hover:brightness-[0.98]',
        className,
      )}
    >
      <span className="flex size-10 shrink-0 items-center justify-center rounded-xl bg-[var(--surface)] text-[var(--accent)]">
        <Smartphone className="size-6" aria-hidden />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block font-semibold">{t('offline.install_title')}</span>
        <span className="block text-[15px] text-[var(--ink-2)]">{t('offline.install_body')}</span>
      </span>
      <span className="hidden shrink-0 items-center gap-1 font-semibold text-[var(--accent)] sm:inline-flex">
        {t('offline.install_link')}
        <ChevronRight className="size-5" aria-hidden />
      </span>
      <ChevronRight className="size-5 shrink-0 text-[var(--accent)] sm:hidden" aria-hidden />
    </Link>
  );
}
